var DateRangePicker = $.extend({/* DateRangePicker */}, BaseComponent, {

	componentSelector: '.input-daterange',

	dateTo: null,
	dateFrom: null,

	init: function() {
		this.initDateRangePickers();
	},

	initDateRangePickers: function() {

		$(this.componentSelector).each((function (index, element) {
			this.initializeDatePicker(element);
		}).bind(this));
	},

	initializeDatePicker: function(element) {

		$(element).datepicker({
			language: DatePicker.getDatepickerCodeLanguage(Language.getLanguage()),
			format: 'dd/mm/yyyy',
			endDate: '0d',
			forceParse: false,
			assumeNearbyYear: false,
			autoclose: true,
			container: '.input-daterange',
			orientation: device.mobile() ? 'left top' : 'auto'
		}).on('changeDate', this.dateChanged).on('input', this.focused);
	},

	dateChanged: function(event) {

		var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;

		if ( ($(event.target).attr('name') === 'range_date_from') && (pattern.test($(event.target).val())) ) {

			this.dateFrom = new Date(event.date.getFullYear(),event.date.getMonth(),event.date.getDate(),0,0,0);

		}

	},

	focused: function(event) {

		var pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;

		if ( ($(event.target).attr('name') === 'range_date_from') && (pattern.test($(event.target).parents(this.componentSelector).find('#range_date_from').val())) ) {

			var dateFromArr = $(event.target).parents(this.componentSelector).find('#range_date_from').val().split('/');
			var parsedDate = [null, null, null];
			parsedDate.splice(0, 0, dateFromArr[1]);
			parsedDate.splice(1, 0, dateFromArr[0]);
			parsedDate.splice(2, 3, dateFromArr[2]);
			this.dateFrom = new Date(parsedDate.join('/'));

		} else if ( ($(event.target).attr('name') === 'range_date_to') && (pattern.test($(event.target).parents(this.componentSelector).find('#range_date_to').val())) ) {

			var dateToArr = $(event.target).parents(this.componentSelector).find('#range_date_to').val().split('/');
			var parsedDate = [null, null, null];
			parsedDate.splice(0, 0, dateToArr[1]);
			parsedDate.splice(1, 0, dateToArr[0]);
			parsedDate.splice(2, 3, dateToArr[2]);
			this.dateTo = new Date(parsedDate.join('/'));
			$(event.target).parents(this.componentSelector).find('#range_date_to').datepicker('update', this.dateTo);

			if ( (this.dateFrom != null) && (this.dateTo != null) && (this.dateTo < this.dateFrom) ) {

				$(event.target).parents(this.componentSelector).find('#range_date_from').datepicker('update', this.dateTo);

			} else if ( (this.dateFrom != null) && (this.dateTo != null) && (this.dateTo >= this.dateFrom) ) {

				$(event.target).parents(this.componentSelector).find('#range_date_from').datepicker('update', this.dateFrom);

			}
		} else if ( ($(event.target).attr('name') === 'range_date_to') && (!pattern.test($(event.target).parents(this.componentSelector).find('#range_date_to').val())) ) {

			$(event.target).parents(this.componentSelector).find('#range_date_from').datepicker('update', this.dateFrom);

		}

	},

	reinitDateRangePickers: function() {

		$(this.componentSelector).each((function (index, element) {

			$(element).datepicker('remove');

			var valFrom = $($(element).find('input[type=text]')[0]).val();
			var valTo = $($(element).find('input[type=text]')[1]).val();

			$(element).find('input[type=text]').val('');

			this.initializeDatePicker(element);

			$($(element).find('input[type=text]')[0]).val(valFrom);
			$($(element).find('input[type=text]')[1]).val(valTo);

		}).bind(this));

	}
})
